<template>
    <div class="body">
        <p class="font1" style="padding-top: 8vh;">
            📚 书籍是通向智慧的钥匙，让我们在知识的海洋中遨游，发现更好的自己！
        </p>
    
        <div class="wrapper">
            <div v-for="(book, index) in books" :key="index" class="book-card">
                <div class="inline-row">
                    <input type="checkbox" :value="book.title" v-model="selectedCourses" />
                    <strong>{{ book.title }}</strong>
                </div>
                <div class="book-info">
                    <p class="book-author" style="text-align: center;">{{ book.author }}</p>
                    <div class="book-desc" v-html="book.description"></div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      ReportData: {
        type: Object,
        required: false
      },
      selected: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selectedCourses: [],
        books: [
          {
            title: '非暴力沟通',
            author: '[美] 马歇尔·卢森堡 ',
            description: `本书的核心是以需要为桥梁，语言从评价转向澄清，从命令转向选择。本书以四要素——观察（不带评判）、感受（说出情绪）、需要（识别未满足的普遍需要）、请求（清晰可执行）——将冲突从指责转为协作。配合自我连接与同理倾听，它能显著提升反馈、协商与冲突调解的质量。`,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=54990'
          },
          {
            title: '哈佛经典谈判术',
            author: '[美] 迪帕克·马尔霍特拉 /[美] 马克斯·巴泽曼',
            description: `本书以行为经济学与决策科学为底层逻辑，提供一套可复制的谈判流程：识别并修正偏误，设定BATNA与保留价，运用锚定、打包、多议题同换与期限管理，在创造价值与分配价值间取得平衡。`,
            // url: 'https://iedu.foxconn.com/public/play/playCourse?courseId=53931'
          }
        ]
      };
    },
    watch: {
      selectedCourses: {
        deep: true,
        handler(newVal) {
          this.$emit('update:selected', newVal);
        }
      }
    },
    mounted() {
      this.selectedCourses = [...this.selected];
    },
  };
  </script>
  <style scoped>
  .body {
      background: 
      url("../../assets/25November/logo.png") right  top  no-repeat,
      url("../../assets/25November/bg.jpg")  no-repeat;
      background-size:100% 100%,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 96%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #d03327;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #36854f;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .wrapper {
      width: 94%;
      text-align: justify;
      margin: 0 auto;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  .inline-row {
    display: flex;
    align-items: center;     /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    gap: 8px;                /* 他们之间间距 */
    width: 100%;     
    color: #d03327;  
    padding-top: 10px;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25November/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font1{
    text-align: center;
  }
  .wrapper {
      width: 80%;
      text-align: justify;
      margin: 0 auto;
      font-size: 18px;
      /* border-radius: 10px; */
      /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  }
}
</style>